import LoLResultDetailsCard from './LoLResultDetailsCard';

export default LoLResultDetailsCard;
